export const mapMessageTemplate = (template: string, variableMap: Record<string, any>): string => {
    if (!template) return "";
    let mapped = template;

    const regex = /\{\{(.*?)\}\}/g;

    mapped = mapped.replace(regex, (match, variableName) => {
        const key = variableName.trim();
        if (variableMap.hasOwnProperty(key)) {
            const val = variableMap[key];
            return val !== undefined && val !== null ? String(val) : "";
        }

        const lowerKey = key.toLowerCase();
        const foundKey = Object.keys(variableMap).find(k => k.toLowerCase() === lowerKey);
        if (foundKey) {
            const val = variableMap[foundKey];
            return val !== undefined && val !== null ? String(val) : "";
        }

        return match;
    });

    return mapped;
};
